export const baseBiIconProps = (size: number) => ({ className: "gr-icon", style: { width: size, height: size } })
export const BaseBiIconProps = baseBiIconProps(24);
export const BaseBiIconSmallProps = baseBiIconProps(16);
